// Quanto de cada boleto fica com a Vigor Energy.
//
// Coluna "Parte da Vigor" das listas de boletos do Painel Executivo. A regra é
// a MESMA da previsão de recebíveis ("Quanto vou receber"), reaproveitada e não
// reescrita: em UC de empresa parceira a Vigor fica com
// `(total do boleto − Equatorial) × percentual_vigor` — hoje 65%, os outros 35%
// vão para a Gran. Em UC da Vigor o boleto inteiro é dela.
//
// Função pura: roda sob `node --test` com type-stripping.

import type { FaturaPainel } from './types.ts';
import { valorDevido } from '../statusBoleto.ts';
import { parteDaVigor, valorSemEquatorial } from '../recebiveisUc.ts';

export function parteVigorDaFatura(
  f: FaturaPainel,
  percentualVigorPorParceira: ReadonlyMap<string, number>,
): number {
  if (!f.empresa_parceira_id) return valorDevido(f);
  return parteDaVigor(valorSemEquatorial(f, true), percentualVigorPorParceira.get(f.empresa_parceira_id));
}
